import { MeasurementUnitDto } from "./measurement-unit.dto";

export class SensorDto {
    id!: number;
    name?: string;
    nameOnScreen?: string;
    description?: string;
    value?: number;
    orderId!: number;
    orderProcessId!: number;
    machineId!: number;
    multiplier!: number;
    isPackagingCounter?: boolean;
    isPrintOrder?: boolean;
    isAccumulated?: boolean;
    isQuantityProduced?: boolean;
    showInScreen!: boolean;
    measurementUnit?: MeasurementUnitDto;
    component?: string;
}
